jQuery(document).ready(function($) {
    if ($('.greenhouse-careers').length) {
        $(document).on('change', '.greenhouse-careers .filters select.filters-button-group', function() {
            let filter_values = {};
            $('.greenhouse-careers .filters select.filters-button-group').each(function() {
                filter_values[$(this).data('filter-group')] = $(this).val();
            })

            $('.greenhouse-careers .positions-list article').each(function() {
                let flag_show = true;

                for (var filter_key in filter_values) {
                    if (filter_values[filter_key] != '*' && $(this).data(filter_key) != filter_values[filter_key]) {
                        flag_show = false;
                    }
                }

                if (flag_show) {
                    $(this).removeClass('hide');
                } else {
                    $(this).addClass('hide');
                }
            })
        })
    }
});


// WEBPACK FOOTER //
// ./scripts/blocks/greenhouse-careers.js